<template>
    <div
        class="h-screen pos-relative overflow-hidden"
        :class="{
            [`book-bg-${color}`]: color,
        }"
    >
        <div
            class="brand-book-section overflow-hidden w-full h-full pos-relative"
            :style="{
                transition: `opacity ${animationDuration}ms ease-in-out, transform ${animationDuration}ms ease-in-out`,
                transform: `translateY(${isAfter ? 100 : isPrevious ? -100 : 0}px) scale(${
                    isActive ? 1 : 1.2
                })`,
                opacity: isActive ? 1 : 0,
            }"
        >
            <div class="brand-book-section-hero pos-relative" :class="{ animate: isActive }">
                <slot name="hero"></slot>
            </div>

            <div class="brand-book-section-description w-full text-center pt-4 px">
                <h2 class="text-uppercase my-0" style="font-size: max(4vw, 30px)">
                    {{ title }}
                </h2>
                <div
                    class="brand-book-details-btn d-inline-block rounded-full bg-white shadow-5 mx-auto my-4 pos-relative cursor-pointer"
                    :class="{ animate: callToOpen }"
                    style="height: max(3vw, 3rem); width: max(3vw, 3rem); font-size: 2rem"
                    @click="showDetails = true"
                >
                    <p class="pos-absolute my-0 pos-center">
                        <i class="icon-cr icon-plus text-default-4 mx-0" />
                    </p>
                </div>
                <BrandBookChevronDown
                    :style="{ visibility: isLast ? 'hidden' : 'visible' }"
                    @click.native="$emit('go-next')"
                />
            </div>
        </div>
        <div
            class="pos-absolute bg-black pos-all no-pointer-events"
            :style="{
                opacity: isActive ? 0 : 0.75,
                transition: `opacity ${animationDuration}ms ease-in-out`,
            }"
        />

        <transition name="fade">
            <BrandBookSectionContents
                v-if="showDetails"
                :title="title"
                :large="large"
                @close="showDetails = false"
                @wheel.stop
            >
                <slot />
            </BrandBookSectionContents>
        </transition>
    </div>
</template>

<script>
    import Modal from '../common/container/Modal';
    import BrandBookSectionContents from './BrandBookSectionContents';
    import BrandBookChevronDown from './BrandBookChevronDown';

    export default {
        name: 'BrandBookSection',

        components: { BrandBookChevronDown, BrandBookSectionContents, Modal },

        props: {
            title: { type: String, required: true },
            reverseOrder: { type: Boolean },
            color: { type: String, required: true },
            isPrevious: { type: Boolean, required: true },
            isAfter: { type: Boolean, required: true },
            isLast: { type: Boolean, required: true },
            callToOpen: { type: Boolean },
            large: { type: Boolean },
        },

        data() {
            return {
                showDetails: false,
                originalTopPosition: null,
                translateY: 0,
                animationDuration: 750,
            };
        },

        watch: {
            showDetails(to) {
                this.$emit('show-details', to);
            },
        },

        computed: {
            isActive() {
                return !this.isPrevious && !this.isAfter;
            },
        },
    };
</script>
